import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 6.75V15M15 9V17.25M15.503 20.748L20.378 18.311C20.759 18.121 21 17.731 21 17.305V4.82C21 3.984 20.12 3.44 19.372 3.814L15.503 5.748C15.186 5.907 14.813 5.907 14.497 5.748L9.503 3.252C9.34682 3.17393 9.17461 3.13329 9 3.13329C8.82539 3.13329 8.65318 3.17393 8.497 3.252L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18C3 20.016 3.88 20.56 4.628 20.186L8.497 18.252C8.814 18.093 9.187 18.093 9.503 18.252L14.497 20.749C14.814 20.907 15.187 20.907 15.503 20.749V20.748Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }